import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import InputField from 'forms/shared/fields/input'
import ContactField from 'forms/shared/fields/contact';
import SelectDropdownField from 'forms/shared/fields/dropdown'
import CheckBoxField from 'forms/shared/fields/checkbox';
import AvatarField from 'forms/shared/fields/avatar'

const checkBoxClass = `mr-2 shadow-sm rounded-none border text-gray-700 leading-tight focus:border-0 focus:outline-none focus:shadow-outline`
const checkBoxLabel = `block text-gray-700 text-sm`

const inputErrorClass = `border-red-500 leading-tight`

const ProfileFields = ({ form, placesOptions }) => (
  <>
    <AvatarField form={form} />
    <Field
      type="text"
      name="first_name"
      groupClassName="my-4"
      placeHolder="First name"
      inputClassName="block border text-sm border-grey-light w-full p-3 rounded-lg"
      inputGroupClassName=""
      inputErrorClassName="border-action-danger"
      errorClassName="text-action-danger text-xs slab"
      component={InputField}
    />
    <Field
      type="text"
      name="last_name"
      groupClassName="my-4"
      placeHolder="Last name"
      inputClassName="block border text-sm border-grey-light w-full p-3 rounded-lg"
      inputGroupClassName=""
      inputErrorClassName="border-action-danger"
      errorClassName="text-action-danger text-xs slab"
      component={InputField}
    />
    <Field
      type="text"
      name="email"
      groupClassName="my-4"
      placeHolder="Email"
      inputClassName="block border text-sm border-grey-light w-full p-3 rounded-lg"
      inputGroupClassName=""
      inputErrorClassName="border-action-danger"
      errorClassName="text-action-danger text-xs slab"
      component={InputField}
    />
    <Field
      type="tel"
      name="phone"
      groupClassName="my-4"
      placeHolder="Contact Number"
      inputClassName="block border text-sm border-grey-light w-full p-3 rounded-lg"
      inputGroupClassName=""
      inputErrorClassName="border-action-danger"
      errorClassName="text-action-danger text-xs slab"
      component={ContactField}
    />
    <Field
      type="text"
      name="company"
      groupClassName="my-4"
      placeHolder="Company"
      inputClassName="block border text-sm border-grey-light w-full p-3 rounded-lg"
      inputGroupClassName=""
      inputErrorClassName="border-action-danger"
      errorClassName="text-action-danger text-xs slab"
      component={InputField}
    />
    <Field
      type="dropdown"
      name="place"
      options={placesOptions}
      placeholder={'Location'}
      groupClassName="my-4"
      inputClassName="pl-2 pt-2 regular text-xs"
      inputGroupClassName=""
      inputErrorClassName="border-action-danger"
      errorClassName="text-action-danger text-xs slab"
      component={SelectDropdownField}
    />
    <Field
      type={'checkbox'}
      name={'newsletter'}
      label={'Receive FlySpaces Newsletter'}
      groupClassName="mb-4 flex items-center justify-start pt-5"
      labelClassName={checkBoxLabel}
      inputClassName={checkBoxClass}
      inputErrorClassName={inputErrorClass}
      errorClassName="text-red-500 text-xs italic"
      component={CheckBoxField} />
  </>
);

ProfileFields.propTypes = {
  form: PropTypes.string,
  placesOptions: PropTypes.array,
}

export default ProfileFields;
